import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BannerWithTitleBlockData from '../../../Models/Content/BannerWithTitleBlockData';
import BannerWithTitle from './BannerWithTitleBlock';

export default class BannerWithTitleBlock extends EpiComponent<BannerWithTitleBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = [];

    return (
      <div className={cssClasses.join(" ")}>
            <BannerWithTitle iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}
